import type { FetchConfig } from '@nlo/nuxt-common/api/helper-types';
import type { components, paths } from '../../generated/portal-api';

export function createProfileApi(fetchConfig: FetchConfig) {
	const client = fetchConfig.createClient<paths>();

	return {
		deleteProfile(bankAccount: string) {
			// return client.POST('/api/my/profile/verwijder-account-aanvraag', { body: { bankAccount } });
			return client.POST('/api/my/profile/verwijder-account-aanvraag', { body: { bankAccount } });
		},
		updateProfile(args: components['schemas']['UpdateAccountRequestViewModel']) {
			return client.POST('/api/my/profile', { body: args });
		},
		changeEmail(args: components['schemas']['UpdateEmailRequestViewModel']) {
			return client.POST('/api/my/profile/email', { body: args });
		},

		activatePayoutToWallet() {
			return client.POST('/api/my/profile/activate-payout-to-wallet');
		},

		retrieveChangePasswordUrl() {
			return client.GET('/api/my/update-password-link');
		},

		changeMfa(enable: boolean) {
			return client.POST('/api/my/change-mfa', { body: { enable } });
		},

		getSecuritySettings() {
			return client.GET('/api/my/security-settings');
		},

		sendEmailVerification() {
			return client.POST('/api/my/profile/resend-email-verification');
		},
	};
}
